module.exports = __webpack_public_path__ + "img/btnn.56894a23.png";